import { Select, SearchField } from '@dreamtree-org/twreact-ui';

/**
 * Search box + any number of selects, collapsing to one column on phones.
 *   filters: [{ key, label, options: [{ value, label }], value }]
 *   compact: for narrow panels (search full width, selects two per row)
 */
export default function FilterBar({ q, onQ, placeholder = 'Search…', filters = [], onFilter, compact = false }) {
  const grid = compact ? 'sm:grid-cols-2' : `sm:grid-cols-2 ${filters.length >= 2 ? 'lg:grid-cols-4' : 'lg:grid-cols-3'}`;
  const searchSpan = compact ? 'sm:col-span-2' : filters.length >= 2 ? 'sm:col-span-2' : 'lg:col-span-2';
  return (
    <div className={`grid gap-3 ${grid}`}>
      <div className={searchSpan}>
        <SearchField aria-label="Search" value={q} onValueChange={onQ} placeholder={placeholder} />
      </div>
      {filters.map((f) => (
        <Select key={f.key} label={f.label} options={f.options} value={f.value} onChange={(v) => onFilter(f.key, v)} closeOnSelect />
      ))}
    </div>
  );
}
